import { Box, Grid, Typography } from "@mui/material";
import React, { useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import GlobalButton from "../../../components/CustomButton";
import Label from "../../../components/Label";
import Loader from "../../../components/Loader";
import SnackbarAlert from "../../../components/SnackBar";
import TextInput from "../../../components/TextInputs";
import appcolors from "../../../constants/Colors";
import { helper } from "../../../helper/uploader";
import { sendOtpBusinessAccount } from "../../../services/Auth";
import { signupValidation } from "../../../utils/Validation";

const shopType = ["Spa", "Saloon", "Both"];

const SignupForm = () => {
  const navigate = useNavigate();
  const [showPass, setShowPass] = useState(false);
  const dispatch = useDispatch();
  const [showConfirmPass, setShowConfirmPass] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [inputValues, setInputValues] = useState({
    firstName: "",
    lastName: "",
    companyEmail: "",
    isEmailValid: "",
    contact: "",
    password: "",
    confirmPass: "",
  });

  const [inputError, setInputError] = useState({
    firstName: false,
    lastName: false,
    companyEmail: false,
    isEmailValid: false,
    contact: false,
    password: false,
    confirmPass: false,
  });

  const [snackbarProps, setSnackbarProps] = useState({
    open: false,
    type: "",
    message: "",
  });

  const handleSnackbarVal = (open, type, message) => {
    setSnackbarProps({
      open,
      type,
      message,
    });
  };
  const handleCloseSnackbar = () => {
    handleSnackbarVal(false, "", "");
  };

  const handleSingup = async () => {
    try {
      const validate = signupValidation(inputValues, setInputError);
      if (validate) {
        return;
      }
      const { firstName, lastName, companyEmail, contact, password } =
        inputValues;

      let payload = {
        firstName,
        lastName,
        email: companyEmail,
        contactNumber: contact,
        password,
      };

      setIsLoading(true);
      const responce = await sendOtpBusinessAccount(payload);
      setIsLoading(false);
      if (responce.status == 200 || responce.status == 201) {
        handleSnackbarVal(true, "success", responce?.data?.message);
        setTimeout(() => {
          navigate("/sign-up/verify", { state: payload });
        }, 1000);
      } else {
        handleSnackbarVal(true, "error", responce?.data?.message);
      }
    } catch (error) {
      setIsLoading(false);
      handleSnackbarVal(true, "error", error?.data?.message);
      console.log("🚀 ~ handleSingup ~ error:", error);
    }
  };

  const handleChangeValues = (event) => {
    const { name, value } = event.target;
    setInputError((prevError) => ({
      ...prevError,
      [name]: false,
      isEmailValid: name === "email" ? false : inputError.isEmailValid,
    }));
    setInputValues((pre) => ({ ...pre, [name]: value }));
  };

  const handleUploadImage = async (e) => {
    let file = e.target.files[0];
    try {
      setIsLoading(true);
      const resss = await helper.uploadMediaService(file);
      setIsLoading(false);
      setInputValues({
        ...inputValues,
        image: resss,
      });
    } catch (error) {
      console.log(error, "errorerrorerror");
      setIsLoading(false);
    }
  };
  return (
    <Box component={"form"} sx={{ mt: 3 }}>
      <Loader isLoading={isLoading} />
      <SnackbarAlert
        handleCloseSnackbar={handleCloseSnackbar}
        snackbarProps={snackbarProps}
      />
      <Grid container spacing={2}>
        {/* <Grid item xs={12} md={12}>
          <Label labelText="Branch Logo" />
          <Stack
            justifyContent={"center"}
            alignItems={"center"}
            border={`1px solid ${inputError.image ? "#d32f2f" : "#d7d7d7"}`}
            sx={{ cursor: "pointer", height: { xs: 200, md: 200 } }}
            onClick={() => openImageFile.current.click()}
          >
            {inputValues?.image ? (
              <img
                src={inputValues?.image}
                alt={"upload-image"}
                width={"45%"}
                height={"100%"}
              />
            ) : (
              <>
                <img
                  src={allImages.uploadImage}
                  alt={"upload-image"}
                  width={100}
                />
                <span>Upload Image</span>
              </>
            )}
          </Stack>
          {inputError.image && (
            <FormHelperText sx={{ color: "#d32f2f" }}>
              Image is required
            </FormHelperText>
          )}
          <input
            type="file"
            ref={openImageFile}
            onChange={handleUploadImage}
            style={{ display: "none" }}
          />
        </Grid> */}
        {/* <Grid item xs={12} md={6}>
          <Box sx={{ my: { xs: 0, md: 3 } }}>
            <Typography variant="body2">
              Size must be 1800*1200 large picture
            </Typography>
            <Typography
              variant="body2"
              display={"inline-block"}
              color={"primary.main"}
              sx={{ cursor: "pointer" }}
              onClick={() => openImageFile.current.click()}
            >
              {inputValues.image ? "Change" : "Upload"}
            </Typography>
          </Box>
        </Grid> */}
        {/* <Grid item xs={12}>
          <Label labelText="Branch Name" htmlFor={"branchName"} required />
          <TextInput
            inputError={inputError.branchName}
            helperText={
              inputError.branchName ? "Branch name is required" : null
            }
            id={"branchName"}
            required={true}
            placeholder={"Enter Branch Name"}
            type={"text"}
            name="branchName"
            value={inputValues.branchName}
            onChange={handleChangeValues}
          />
        </Grid>
        <Grid item xs={12}>
          <Label labelText="Business Name" htmlFor={"name"} required />
          <TextInput
            inputError={inputError.name}
            helperText={inputError.name ? "Bussiness name is required" : null}
            id={"name"}
            required={true}
            placeholder={"Enter Bussiness Name"}
            type={"text"}
            name="name"
            value={inputValues.name}
            onChange={handleChangeValues}
          />
        </Grid> */}
        <Grid item xs={12}>
          <Label labelText="First Name" htmlFor={"firstName"} required />
          <TextInput
            inputError={inputError.firstName}
            helperText={inputError.firstName ? "First name is required" : null}
            id={"firstName"}
            required={true}
            placeholder={"Enter First Name"}
            name="firstName"
            value={inputValues.firstName}
            onChange={handleChangeValues}
          />
        </Grid>
        <Grid item xs={12}>
          <Label labelText="Last Name" htmlFor={"lastName"} required />
          <TextInput
            inputError={inputError.lastName}
            helperText={inputError.lastName ? "Last name is required" : null}
            id={"lastName"}
            required={true}
            placeholder={"Enter Last Name"}
            name="lastName"
            value={inputValues.lastName}
            onChange={handleChangeValues}
          />
        </Grid>
        <Grid item xs={12}>
          <Label labelText="Company email address" htmlFor={"email"} required />
          <TextInput
            inputError={inputError.companyEmail || inputError.isEmailValid}
            helperText={
              inputError.companyEmail
                ? "Email is required"
                : inputError.isEmailValid
                ? "Invalid email format"
                : null
            }
            id={"email"}
            required={true}
            placeholder={"Enter Email Address"}
            type={"email"}
            name="companyEmail"
            value={inputValues.companyEmail}
            onChange={handleChangeValues}
          />
        </Grid>
        <Grid item xs={12}>
          <Label labelText="Contact number" htmlFor={"email"} required />
          <PhoneInput
            country={"us"}
            inputClass="cutom-phone-input"
            buttonClass="custom-phone-input-button"
            value={inputValues.contact}
            onChange={(phone) =>
              setInputValues((prevState) => ({
                ...prevState,
                contact: phone,
              }))
            }
          />
        </Grid>
        {/* <Grid item xs={12}>
          <Stack
            mb={"5px"}
            direction={"row"}
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            <Label
              labelText="Location"
              htmlFor={"location"}
              required
              labelProps={{ marginBottom: 0 }}
            />
            <Stack direction={"row"}>
              <Label
                labelText="Current"
                htmlFor={"location"}
                labelProps={{ marginBottom: 0, fontSize: "0.775rem" }}
              />
              <LocationOnOutlinedIcon
                htmlColor={appcolors.black}
                sx={{ fontSize: "1.2rem" }}
              />
            </Stack>
          </Stack>
          <TextInput
            inputError={inputError.location}
            helperText={inputError.location ? "Location is required" : null}
            id={"location"}
            required={true}
            placeholder={"Enter Your Location"}
            type={"text"}
            name="location"
            value={inputValues.location}
            onChange={handleChangeValues}
          />
        </Grid> */}
        {/* <Grid item xs={12}>
          <Stack
            mb={"5px"}
            direction={"row"}
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            <Label
              labelText="Type"
              htmlFor={"type"}
              required
              labelProps={{ marginBottom: 0 }}
            />
            <Label
              labelText="Info"
              htmlFor={"type"}
              labelProps={{ marginBottom: 0, fontSize: "0.775rem" }}
            />
          </Stack>
          <FormControl
            fullWidth
            error={inputError.type}
            sx={globalStyle.selectType}
          >
            <Select
              id="type"
              variant={"outlined"}
              size={"small"}
              name={"type"}
              value={inputValues.type}
              onChange={handleChangeValues}
            >
              {shopType.map((val, index) => (
                <MenuItem key={index} value={val}>
                  {val}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText sx={{ ml: 0, mt: 0 }}>
              {inputError.type ? "Shop type is required" : null}
            </FormHelperText>
          </FormControl>
        </Grid> */}
        <Grid item xs={12}>
          <Label labelText="Password" htmlFor={"password"} required />
          <TextInput
            inputError={inputError.password}
            helperText={inputError.password ? "Password is required" : null}
            id={"password"}
            required
            placeholder={"Enter Password"}
            type={showPass ? "text" : "password"}
            name="password"
            value={inputValues.password}
            onChange={handleChangeValues}
            InputEndIcon={
              showPass ? (
                <Typography
                  variant="body2"
                  color={appcolors.black}
                  onClick={() => setShowPass(false)}
                >
                  Hide
                </Typography>
              ) : (
                <Typography
                  variant="body2"
                  color={appcolors.black}
                  onClick={() => setShowPass(true)}
                >
                  Show
                </Typography>
              )
            }
          />
        </Grid>
        <Grid item xs={12}>
          <Label
            labelText="Confirm Password"
            htmlFor={"confirmPass"}
            required
          />
          <TextInput
            inputError={inputError.password}
            helperText={
              inputError.password ? "Confirm Password is required" : null
            }
            id={"confirmPass"}
            required
            placeholder={"Enter Confirm Password"}
            type={showConfirmPass ? "text" : "password"}
            name="confirmPass"
            value={inputValues.confirmPass}
            onChange={handleChangeValues}
            InputEndIcon={
              showConfirmPass ? (
                <Typography
                  variant="body2"
                  color={appcolors.black}
                  onClick={() => setShowConfirmPass(false)}
                >
                  Hide
                </Typography>
              ) : (
                <Typography
                  variant="body2"
                  color={appcolors.black}
                  onClick={() => setShowConfirmPass(true)}
                >
                  Show
                </Typography>
              )
            }
          />
        </Grid>
      </Grid>
      <Box mt={3}>
        <GlobalButton
          variant={"contained"}
          btnText={"Let’s Create Account"}
          handleClickBtn={handleSingup}
        />
      </Box>
    </Box>
  );
};

export default SignupForm;
